require('./brokerStocksPurchaseOrderSuccess.scss');

const PropTypes = require('prop-types');

// @vendors
const React = require('react');

// @components
const { OKButton } = require('components/commons/OKButton/OKButton');
const { ContentBox } = require('commonsComponents/contentBox');
const { OKBoxTitle } = require('commonsComponents/OKBoxTitle');

// @helpers
const { formatText, FormattedText } = require('core/i18n').i18n;
const DateHelper = require('utilities/dateHelper');

// @constants
const { FIRST_STEP, DATE_FORMAT_ES, CHARGE_ACCOUNT_PREFIX } = require('constants/index');

const CLASS_NAME = 'broker-stocks-purchase-order-success';
const RETURN_TO_CORPORATES_OPERATIONS_LINK = '/myprofile/broker/corporatesOperations';
const GO_TO_MY_WALLET_URL = '/myprofile/broker';

class BrokerStocksPurchaseOrderSuccess extends React.Component {
    constructor(props) {
        super(props);

        this.buildHeader = this.buildHeader.bind(this);
        this.buildField = this.buildField.bind(this);
        this.buildLeftColumnDetails = this.buildLeftColumnDetails.bind(this);
        this.buildRightColumnDetails = this.buildRightColumnDetails.bind(this);
        this.buildFooter = this.buildFooter.bind(this);
    }

    buildField(primaryText, secondaryText, description = <span>&nbsp;</span>, primaryTextInjectStrings = []) {
        return (
            <div className={`${CLASS_NAME}__details-field`}>
                <h5 className={`${CLASS_NAME}__details-primary-text`}>
                    <FormattedText
                        value={primaryText}
                        format="uppercase"
                        injectedStrings={primaryTextInjectStrings}
                    />
                </h5>
                <div className={`${CLASS_NAME}__details-secondary-text`}>
                    {secondaryText}
                </div>
                <div className={`${CLASS_NAME}__details-gray`}>
                    {description}
                </div>
            </div>
        );
    }

    buildFooter() {
        return (
            <div>
                <div className="wizard-success-step__separator" />
                <div className="wizard-success-step__foot-buttons text-right">
                    <span className={`${CLASS_NAME}__corporates-operations-button`}>
                        <OKButton
                            modifier="ghost"
                            to={RETURN_TO_CORPORATES_OPERATIONS_LINK}
                        >
                            <FormattedText
                                value="stocksPurchaseOrder-returnToCorporateOperations"
                            />
                        </OKButton>
                    </span>
                    <OKButton
                        modifier="secondary"
                        to={GO_TO_MY_WALLET_URL}
                    >
                        <FormattedText
                            value="stocksPurchaseOrder-goToMyWallet"
                        />
                    </OKButton>
                </div>
            </div>
        );
    }

    buildHeader() {
        const { immBrokerStocksPurchaseOrder } = this.props;
        const orderNumber = immBrokerStocksPurchaseOrder.get('orderNumber');
        const boxTitleValue = (
            <div>
                <span>
                    {formatText('stocksPurchaseOrder-successTitle')}
                </span>
                <div className="wizard-success-step__success-sub-message">
                    <FormattedText
                        value="stocksPurchaseOrder-successSubtitle"
                        injectedStrings={[orderNumber]}
                    />
                </div>
            </div>
        );

        return (
            <div className="wizard-success-step__highlight">
                <i className="wizard-success-step__success-icon" />
                <div className="wizard-success-step__messages">
                    <OKBoxTitle
                        value={boxTitleValue}
                    />
                </div>
            </div>
        );
    }

    buildLeftColumnDetails() {
        const { immBrokerStocksPurchaseOrder } = this.props;
        const immContract = immBrokerStocksPurchaseOrder.get('contract');
        const immAssociatedAccount = immBrokerStocksPurchaseOrder.get('associatedAccount');
        const immBalance = immAssociatedAccount.get('balance');

        const contractNumber = CHARGE_ACCOUNT_PREFIX + immBrokerStocksPurchaseOrder.getIn(['contract', 'product']) + immContract.get('number');
        const owner = immBrokerStocksPurchaseOrder.get('owner');
        const associatedAccountNumber = immAssociatedAccount.get('number');
        const balanceAmount = immBalance.get('amount');
        const balanceCurrency = immBalance.get('currency');
        const contract = immBrokerStocksPurchaseOrder.get('walletAccountType');

        const contractNumberText = (
            <FormattedText
                value="stocksPurchaseOrder-successContractNumber"
                injectedStrings={[contractNumber]}
            />
        );
        const contractOwnerText = (
            <FormattedText
                value="stocksPurchaseOrder-contractOwnerName"
                injectedStrings={[owner]}
            />
        );

        const associatedAccountText = (
            <FormattedText
                value="stocksPurchaseOrder-associatedAccountId"
                injectedStrings={[associatedAccountNumber]}
            />
        );
        const associatedAccountBalanceText = (
            <FormattedText
                value="stocksPurchaseOrder-associatedAccountBalanceAmount"
                injectedStrings={[balanceAmount, balanceCurrency]}
            />
        );

        // @hardcoded
        const contractField = this.buildField('stocksPurchaseOrder-contract', contract);

        return (
            <div className={`${CLASS_NAME}__details-section-left`}>
                {contractField}
                <div className={`${CLASS_NAME}__details-gray`}>
                    <div className={`${CLASS_NAME}__details-field`}>
                        {contractNumberText}
                        <br />
                        {contractOwnerText}
                    </div>
                    <div>
                        {associatedAccountText}
                        <br />
                        {associatedAccountBalanceText}
                    </div>
                </div>
            </div>
        );
    }

    buildRightColumnDetails() {
        const { immBrokerStocksPurchaseOrder } = this.props;
        const immOperation = immBrokerStocksPurchaseOrder.get('operation');
        const endDate = immOperation.get('endDate');
        const parsedDate = DateHelper.buildFormattedDate(endDate, DATE_FORMAT_ES);
        const amount = immBrokerStocksPurchaseOrder.getIn(['steps', FIRST_STEP, 'amount']);
        const currency = immBrokerStocksPurchaseOrder.getIn(['associatedAccount', 'balance', 'currency']);

        const dateField = this.buildField('broker-rightsBuySidebarDeadlineLabel', parsedDate);
        const amountField = this.buildField('stocksPurchaseOrder-amount', amount, undefined, [currency]);

        return (
            <div className={`${CLASS_NAME}__details-section-right`}>
                {dateField}
                {amountField}
            </div>
        );
    }

    render() {
        return (
            <ContentBox>
                {this.buildHeader()}
                <div className={`row ${CLASS_NAME}__details-container`}>
                    <div className="col-xs-4">
                        {this.buildLeftColumnDetails()}
                    </div>
                    <div className="col-xs-8">
                        {this.buildRightColumnDetails()}
                    </div>
                </div>
                {this.buildFooter()}
            </ContentBox>
        );
    }
}

BrokerStocksPurchaseOrderSuccess.propTypes = {
    immBrokerStocksPurchaseOrder: PropTypes.object.isRequired
};

module.exports = BrokerStocksPurchaseOrderSuccess;
